(() => {
  const get = (id) => document.getElementById(id);
  if (!get('maValue')) return;
  const fields = { ma: get('maValue'), percent: get('percentValue'), physical: get('physicalValue') };
  const slider = get('maSlider');
  const status = get('faultBanner');
  let source = 'ma';
  const read = (field) => field.value.trim() === '' ? NaN : Number(field.value);
  const format = (value) => String(Number(value.toPrecision(12)));

  function unit() {
    return get('unitSelect').value === 'custom' ? get('unitCustom').value.trim() || 'unit' : get('unitSelect').value;
  }

  function invalid(message) {
    for (const [key, field] of Object.entries(fields)) {
      if (key !== source) field.value = '';
    }
    status.className = 'fault-banner fault-danger';
    status.textContent = message;
    status.style.display = 'flex';
    slider.disabled = true;
    slider.style.setProperty('--slider-pct', '0%');
  }

  function update() {
    const low = read(get('engLow'));
    const high = read(get('engHigh'));
    const span = high - low;
    get('engLow').setAttribute('aria-invalid', String(!Number.isFinite(low)));
    get('engHigh').setAttribute('aria-invalid', String(!Number.isFinite(high)));
    if (![low, high, span].every(Number.isFinite)) return invalid('Enter finite engineering range limits.');
    if (span === 0) return invalid('Engineering range limits must be different.');
    const value = read(fields[source]);
    fields[source].setAttribute('aria-invalid', String(!Number.isFinite(value)));
    if (!Number.isFinite(value)) return invalid('Enter a finite value to convert.');
    const pct = source === 'ma' ? ((value - 4) / 16) * 100 : source === 'percent' ? value : ((value - low) / span) * 100;
    const values = { ma: 4 + pct / 100 * 16, percent: pct, physical: low + pct / 100 * span };
    if (!Object.values(values).every(Number.isFinite)) return invalid('Result is too large. Use smaller values.');
    for (const [key, field] of Object.entries(fields)) {
      if (key !== source) field.value = format(values[key]);
      field.setAttribute('aria-invalid', 'false');
    }
    slider.disabled = false;
    slider.value = values.ma;
    slider.style.setProperty('--slider-pct', Math.max(0, Math.min(100, pct)) + '%');
    get('unitLabel').textContent = unit();
    const outside = values.ma < 4 || values.ma > 20;
    status.className = 'fault-banner ' + (outside ? 'fault-warning' : 'fault-ok');
    status.style.display = 'flex';
    status.textContent = outside
      ? 'Outside 4–20mA — result is extrapolated. Check the transmitter range and diagnostics.'
      : 'Signal within 4–20mA. This calculation does not verify equipment health.';
  }

  window.convertFrom = (nextSource) => {
    if (nextSource === 'slider') {
      fields.ma.value = slider.value;
      source = 'ma';
    } else if (fields[nextSource]) source = nextSource;
    update();
  };
  window.recalculateCurrentRange = update;
  window.handleUnitChange = () => {
    const custom = get('unitSelect').value === 'custom';
    get('unitCustom').style.display = custom ? 'block' : 'none';
    get('unitLabel').textContent = unit();
    if (custom) get('unitCustom').focus();
  };
  get('unitCustom').addEventListener('input', () => { get('unitLabel').textContent = unit(); });
  update();
})();
